import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EditModeTableInstance } from '@work4all/components/lib/dataDisplay/basic-table/plugins/useEditMode';

import { Article } from '@work4all/models/lib/Classes/Article.entity';
import { AddServiceContractPosTypeOfPos } from '@work4all/models/lib/Enums/AddServiceContractPosTypeOfPos.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useDeepMemo } from '@work4all/utils/lib/hooks/use-deep-memo';

import { ArticlePickerField } from '../../../../../../../../../../components/entity-picker/ArticlePickerField';
import { settings, useSetting } from '../../../../../../../../../../settings';
// ToDo: WW-7459 Move to shared shadow folder
import { ARTICLE_POSITIONS_DATA } from '../../../../../../erp/components/tab-panels/positions/components/constants';
import { ShadowServiceContractObjectAddComponentArgs } from '../../../../../hooks/use-shadow-service-contract-object-api';
import { usePositionTableActions } from '../hooks/use-position-table-actions';

export interface ArticlePickerCellProps {
  cell: {
    row: {
      index: number;
    };
  };
  isEditMode: boolean;
  onAddComponent?: (props: ShadowServiceContractObjectAddComponentArgs) => void;
  tableInstance: EditModeTableInstance;
  data?: Article;
  label?: string;
}

export const ArticlePickerCell = (props: ArticlePickerCellProps) => {
  const { isEditMode, tableInstance, onAddComponent, data, label } = props;

  const { t } = useTranslation();
  const dataResult = useDeepMemo(
    () => ({ ...ARTICLE_POSITIONS_DATA, ...data }),
    [data]
  );

  const functions = usePositionTableActions({
    disabled: false,
    onAddSpecial: () => {},
  });

  const serviceContractDefaultPositionKind = useSetting(
    settings.serviceContractDefaultPositionKind()
  );

  return (
    <ArticlePickerField
      value={undefined}
      data={dataResult}
      showFunctions
      footerEntity={Entities.serviceContractPosition}
      functions={functions}
      autoFocus={isEditMode && !!tableInstance?.state?.editModeConfig}
      label={label ?? t('MASK.ADD_COMPONENT')}
      input={
        <Typography variant="body2" color="var(--text03)" flex="1">
          {label ?? t('MASK.ADD_COMPONENT')}
        </Typography>
      }
      onChange={(value) => {
        if (!value) {
          return;
        } else if (
          (value as AddServiceContractPosTypeOfPos) in
          AddServiceContractPosTypeOfPos
        ) {
          onAddComponent({
            typeOfPosition: value as AddServiceContractPosTypeOfPos,
          });
        } else {
          const article = value as Article;
          onAddComponent({
            typeOfPosition: AddServiceContractPosTypeOfPos.DEFAULT,
            defaultTypeOfBill:
              serviceContractDefaultPositionKind.value ?? undefined,
            article: {
              ...article,
              id: article.id || 0,
            } as Article,
            articleIds: [article.id],
          });
        }
      }}
    />
  );
};
